import '../stylesheets/frontend/frontend.css.scss'
import { Application } from 'stimulus'
import { definitionsFromContext } from 'stimulus/webpack-helpers'

import ReactOnRails from 'react-on-rails'
import MiniRateChart from '../bundles/components/chart/MiniRateChart'
import SidebarPairsTable from '../bundles/components/SidebarPairsTable'

const application = Application.start()
const context = require.context(
  'controllers',
  true,
  /^(?!.*\/admin\/).*_controller\.(js|ts)$/
)
application.load(definitionsFromContext(context))

ReactOnRails.register({
  MiniRateChart,
  SidebarPairsTable,
})
